<template>
  <div class="opera-info_">
    <topNav  :simple-title='true'  :title="$t('info_title')"></topNav>
    <div class="tags">
      <div class="tag " @click="getInfo(null)" :class="{active:getParams.readStatus === null}">{{$t('info_readStatusNull')}}</div>
      <div class="tag" @click='getInfo(0)' :class="{active:getParams.readStatus===0}">{{$t('info_readStatus0')}}</div>
      <div class="tag" @click='getInfo(1)' :class="{active:getParams.readStatus===1}">{{$t('info_readStatus1')}}</div>
    </div>
    <div class="messages l_o_btm" v-infinite-scroll="getNextPage" infinite-scroll-disabled="loading"
         infinite-scroll-distance="20">
      <div class="mess" v-for="(item,index) in msgInfo" :key="item.id">
        <p class="msgTime" v-if="index==0 || diffDay(item.createDatetime,msgInfo[index-1].createDatetime)">
          {{item.createDatetime | datefomate }}</p>
        <mt-cell-swipe :right="[
                    {
                        content: view,
                        style: {background: 'red', color: '#fff',borderRight:'1px solid #fff' },
                        handler:function(){look(item.id)}
                    },
                    {
                        content: deleteString,
                        style: {background: 'red', color: '#fff' },
                        handler:function(){delMsg(item.id,index)}
                    }
                ]">
          <div class="msgInfo" slot="title" @click="look(item.id,index)">
            <div class="msgTitle"><i class="point" :class="{read:item.readStatus==1}"></i>{{item.title}}
              <div class="right">{{item.createDatetime | timefomate }}</div>
            </div>
            <div class="msgContent">
              <div class="msgSummary">
                {{item.overview}}
              </div>
            </div>
          </div>
        </mt-cell-swipe>
      </div>
      <div class="loadingli" v-show="loading">
        <mt-spinner :type="2"></mt-spinner>
      </div>
      <div class="dx" v-if="msgInfo != undefined && msgInfo.length > 6 && !hasNext">
        　<span>{{$t('loading_end_message')}}</span>　
      </div>
      <nothing :condition="msgInfo != null && msgInfo.length == 0"></nothing>
    </div>
    <foot-nav sta='2' ref="footnav"></foot-nav>
  </div>
</template>
<script>
  import footNav from "../operaCommon/footNav";
  import nothing from "../operaCommon/nothing";
  import moment from "moment";
  import {CellSwipe, Toast, InfiniteScroll} from "mint-ui";

  export default {
    data() {
      return {
        msgInfo: [],
        getParams: {
          pageSize: 15,
          pageOffset: 0,
          readStatus: null //所有消息状态 0未读 1已读
        },
        loading: false,
        hasNext: false
      };
    },
    computed: {
      view() {
        return this.$t("view");
      },
      deleteString() {
        return this.$t("delete");
      },
      msg_delete_success() {
        return this.$t("msg_delete_success");
      }
    },
    mounted() {
      this.getInfo(null);
    },
    methods: {
      getInfo(index) {
        this.getParams.readStatus = index;
        this.msgInfo = null;
        this.getParams.pageOffset = 0;
        this.getnextInfo();
      },
      getnextInfo() {
        this.loading = true;
        this.$http
          .post("/mobilepmsapi/message/messages", this.getParams)
          .then(res => {
            if (res.data.result == 0) {
              if (this.msgInfo == null) {
                this.msgInfo = [];
              }
              _.forEach(res.data.retVal.datas, (el, key) => {
                this.msgInfo.push(el);
              });
              this.getParams.pageOffset += res.data.retVal.datas.length;
              this.hasNext = res.data.retVal.datas.length >= 15;
              this.loading = false;
            }
          });
      },
      getNextPage() {
        if (!this.loading && this.hasNext) {
          this.getnextInfo();
        }
      },
      delMsg(id, index) {
        this.$http.post("/mobilepmsapi/message/delete/" + id).then(res => {
          if (res.data.result == 0) {
            this.msg(this.msg_delete_success);
            this.$refs.footnav.getData();
            this.msgInfo.splice(index, 1);
          }
        });
      },
      look(id) {
        var url = "/opera/infoDetail?id=" + id;
        if (this.$route.query.redirect != null) {
          url +=
            "&redirect=" +
            encodeURI("/opera/info?redirect=" + this.$route.query.redirect);
        }
        this.$router.push(url);
      },
      diffDay(a, b) {
        return (
          moment(a, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD") !=
          moment(b, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
        );
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 1000
        });
      }
    },
    filters: {
      datefomate(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format("MM月DD日");
      },
      timefomate(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format("HH:mm");
      }
    },
    components: {
      footNav,
      nothing
    }
  };
</script>
<style lang='less'>
  .opera-info_ {
    background-color: #f7f8fa;

    .mint-popup-2 {
      width: 100%;
      height: 50px;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.7);
      backface-visibility: hidden;
    }

    .tags {
      height: 1.0667rem;
      background: #fff;
      overflow: hidden;
      position: fixed;
      top: 1.04rem;
      z-index: 1;
      width: 100%;

      .tag {
        float: left;
        height: 1.0667rem;
        width: 23.3%;
        margin: 0 5%;
        box-sizing: border-box;
        text-align: center;
        color: #393c41;
        line-height: 1.0667rem;

        &.active {
          border-bottom: 0.0533rem solid #fa8e3e;
        }
      }
    }

    .messages {
      width: 100%;
      padding-top: 1.0667rem;
      position: absolute;
      top: 40px;
      bottom: 40px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .mess {
        margin: 0.3rem 0.48rem 0.2rem 0.48rem;

        .msgTime {
          text-align: center;
          color: #999;
          line-height: 1.04rem;
          height: 1.04rem;
          margin-top: -0.2rem;
        }

        .msgInfo {
          background-color: #fff;
          padding: 0.2667rem 0.2133rem 0.1067rem;

          .msgTitle {
            font-size: 0.4267rem;
            color: #000;
            text-align: left;
            margin-bottom: 0.2rem;

            .point {
              float: left;
              width: 0.2133rem;
              height: 0.2133rem;
              border-radius: 50%;
              background-color: red;
              display: block;
              margin-top: 0.08rem;
              margin-right: 0.2133rem;

              &.read {
                background-color: #ddd;
              }
            }

            .right {
              float: right;
              font-size: 12px;
              font-weight: 500;
              color: #999;
            }
          }

          .msgContent {
            margin: 0 0.2667rem 0 0.4266rem;

            .msgSummary {
              color: #999;
              font-size: 0.32rem;
              padding: 0 0.2133rem 0.1333rem 0;
              // border-bottom: 1px solid #eee;
            }

            .toDetail {
              height: 0.88rem;
              color: #999;
              text-align: center;
              line-height: 0.88rem;
            }
          }
        }

        .mint-cell-wrapper {
          background-image: none;
        }
      }
    }

    .mint-spinner-triple-bounce {
      margin: 0.8rem auto;
      text-align: center;
    }

    .space {
      height: 1.1733rem;
    }

    .mint-cell:last-child {
      background-image: none;
    }

    .mint-cell-swipe-buttongroup {
      display: table;
      width: 100%;
      height: 100%;

      .mint-cell-swipe-button {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        // border: 1px solid #666;
        // background: red;
        // &:nth-of-type(2){
        // color:green;
        // background: yellow;
        // }
      }
    }

    .dx {
      padding-bottom: 20px;
      text-align: center;
      height: 20px;
      margin-top: 20px;
      line-height: 20px;
      color: #eee;

      span {
        color: #ddd;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// info.vue?318e99d5